import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './sanolivar-style.css';

import Name from './utils/Name.js';

import Header from './components/Header.jsx';
import Footer from './components/Footer.jsx';
import Form from './components/Form.jsx';
import Slider from './components/Slider.jsx';
import Chatbot from './components/Chatbot.jsx';
import { root, assets } from './utils/Path.js';

const assetsNetworking = './assets/images/networking/';

createRoot(document.getElementById('networking')).render(
    <StrictMode>
        <Header active={"Datacenters"} />
        {/* BANNER */}
        <section className="banner endark">
            <div className="background">
                <video loading="lazy" autoPlay muted loop src={`./assets/videos/banner-networking.mp4`} aria-label='Persona programando en una consola de comandos'></video>
            </div>
            <div>
                <h1>Servicios de Networking</h1>
            </div>
        </section>
        <section className="compressed dark">
            <h2>REDES IMPULSADAS POR INTELIGENCIA ARTIFICIAL QUE PRIORIZAN LA SEGURIDAD</h2>
            <p>Descubre los beneficios de una red impulsada por inteligencia artificial que prioriza la seguridad, ofreciendo experiencias seguras y distintivas desde el extremo hasta el campus, el centro de datos y la nube con una base de Zero Trust impulsada por inteligencia artificial.</p>
        </section>
        <section className='compressed'>
            <h2 data-aos="fade-up">Protección del Borde</h2>
            <p data-aos="fade-up" className='stretch'>La solución de SASE (SD-WAN + SSE) de HPE Aruba Networking mejora la seguridad, simplifica las operaciones, aumenta el rendimiento, brinda acceso rápido y seguro a datos y aplicaciones desde cualquier lugar y en cualquier momento.</p>
            <img loading="lazy" data-aos="fade-up" src={`${assetsNetworking}unified-sase.webp`} alt='Diagrama de funcionamiento de Aruba Unified SASE' aria-label='Diagrama de funcionamiento de Aruba Unified SASE' title='Diagrama de funcionamiento de Aruba Unified SASE' />
        </section>
        <section className='compressed c2 d5 bg-alt'>
            <div data-aos="fade-right">
                <h2>Protección del Campus</h2>
                <p>Una red cableada e inalámbrica compuesta por un amplio portafolio con la última tecnología del mercado, gestionada por HPE Aruba Networking Central pone la seguridad en primer plano con la automatización de políticas globales y redes nativas en la nube impulsadas por inteligencia artificial.</p>
            </div>
            <img loading="lazy" data-aos="fade-left" src={`${assetsNetworking}campus.webp`} alt='Productos Aruba Networking' aria-label='Productos Aruba Networking' title='Productos Aruba Networking' />
        </section>
        <section className="compressed c2 d-5 dark">
            <img loading="lazy" data-aos="fade-left" src={`${assetsNetworking}cx10000.webp`} alt='Aruba CX-10000 con Procesador AMD Pensando' aria-label='Aruba CX-10000 con Procesador AMD Pensando' title='Aruba CX-10000 con Procesador AMD Pensando' />
            <div data-aos="fade-right">
                <h2>Protección Centros de Datos</h2>
                <p className=''>Mejora la eficiencia con la solución de Switching CX 10000 de HPE Aruba Networking con AMD Pensando, que integra políticas de seguridad por medio de una microsegmentación sólida a nivel de servidor y máquina virtual. Además, mejora el rendimiento para entornos de IA/ML con estructuras de baja latencia y alto ancho de banda para la conexión de GPUs con una arquitectura basada en servicios distribuidos.</p>
            </div>
        </section>
        <section className="compressed">
            <h2 data-aos="fade-up">Gestión y Visibilidad de Redes</h2>
            <img loading="lazy" data-aos="fade-right" src={`${assetsNetworking}aruba-central.webp`} alt='Interfaz gráfica Aruba Central' aria-label='Interfaz gráfica Aruba Central' title='Interfaz gráfica Aruba Central' />
            <p data-aos="fade-up" className='stretch'>Con HPE Aruba Networking Central, unifica la gestión de redes nativa de la nube a través de sucursales, oficinas remotas, campus, centros de datos e IoT, con información impulsada por IA, automatización de flujos de trabajo y seguridad desde el extremo hasta la nube.</p>
        </section>
        <section className="compressed c2 d5 bg-alt">
            <div data-aos="fade-right">
                <h2>Servicios de ubicación de HPE Aruba Networking</h2>
                <p>Desde el seguimiento de activos hasta la ubicación precisa del usuario final, HPE Aruba Networking potencia las capacidades de localización para interiores desde el borde, con tecnologías como Bluetooth (BLE) y el alcance de medición precisa del tiempo (FTM).</p>
            </div>
            <img loading="lazy" data-aos="fade-left" src={`${assetsNetworking}location.webp`} alt='Servicios de navegación' aria-label='Servicios de navegación' title='Servicios de navegación' />
        </section>
        <Form
            title={'Contáctanos para solicitar Asesoría en Infraestructura'}
            content={'Para más información sobre las distintas formas en que puede hacer uso de nuestra infraestructura tecnológica, por favor completa el formulario.'}
            img={{ src: `${assetsNetworking}contacto.webp`, alt: 'Persona programando en la consola de comandos' }}
            form={[
                {
                    label: 'Nombre contacto',
                    type: 'text',
                    id: 'nombre',
                    placeholder: 'Ingrese su nombre aquí'
                },
                {
                    label: 'Correo electrónico',
                    type: 'email',
                    id: 'email',
                    placeholder: 'Ingrese su correo aquí'
                },
                {
                    label: 'Mensaje',
                    type: 'textarea',
                    id: 'mensaje',
                    placeholder: 'Déjanos un mensaje aquí'
                },
                {
                    label: 'Enviar Mensaje',
                    type: 'submit',
                    id: 'submit',
                }
            ]}
            redirect={`${root}networking.html`}
        />
        <Footer />
        <Chatbot />
    </StrictMode>
)